import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m12.436 18.03-.43553-.25703-.43553.25703-5.6784 3.3499 1.4997-6.2835.12233-.5126-5.3748-4.5512 7.077-.58688.20415-.47082 2.5856-5.963 2.5856 5.963.20415.47082 7.077.58688-5.3748 4.5513.12233.5126 1.4997 6.2835z",
		stroke: "currentColor",
		strokeWidth: 1.7143
	})]
});
const ForwardRef = forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
